// Kurs testlari va imtihonlarini yozish / Quiz and exam authoring (pages/CourseQuizzes, pages/CourseExams):
// the bulk "paste a list" dialog, the answer-key checks and the add-lessons-first affordances.
const quizAuthoring = {
  uz: {
    common: {
      addLessonAction: "Dars qo'shish",
      addModuleAction: "Modul qo'shish",
      passMarkInvalid: "O'tish bali 0 dan 100 gacha butun son bo'lishi kerak.",
    },
    options: {
      pickCorrectHint: "To'g'ri javobni belgilang: variant harfini bosing",
      pickCorrectManyHint: "To'g'ri javoblarni belgilang: bir nechtasini tanlash mumkin",
      pickOneHint: "To'g'ri javobni tanlang",
      trueOption: "To'g'ri",
      falseOption: "Noto'g'ri",
    },
    bulk: {
      open: "Ro'yxatdan qo'shish",
      title: "Savollarni ro'yxatdan qo'shish",
      intro: "Savollarni matn ko'rinishida yozing yoki boshqa joydan nusxalab qo'ying. Ular mavjud savollar oxiriga qo'shiladi.",
      rulesTitle: 'Qanday yoziladi',
      ruleQuestion: "Savol — bitta qator. Oldiga 1) yoki 1. qo'yish mumkin.",
      ruleOptions: "Variantlar — savoldan keyingi qatorlarda, 2 tadan 6 tagacha. A) yoki a. bilan boshlash mumkin.",
      ruleCorrect: "To'g'ri variant oldiga * belgisini qo'ying.",
      ruleBlank: "Savollar orasida bo'sh qator qoldiring.",
      textareaLabel: 'Savollar matni',
      placeholder: "1) «Kitob» ruscha qanday bo'ladi?\n*Книга\nТетрадь\nРучка\n\n2) «Мама» so'zi nimani anglatadi?\nOta\n*Ona\nOpa",
      previewTitle: "Ko'rib chiqish",
      previewEmpty: "Matn yozilgach, tayyor savollar shu yerda ko'rinadi.",
      readyCount: '{count} ta savol tayyor',
      readyCount_plural: '{count} ta savol tayyor',
      errorsCount: '{count} ta xato',
      errorsCount_plural: '{count} ta xato',
      correctTag: "To'g'ri",
      add: "{count} ta savolni qo'shish",
      add_plural: "{count} ta savolni qo'shish",
      addNothing: "Savollarni qo'shish",
      fixErrorsFirst: "Avval xatolarni tuzating: xatoli savollar qo'shilmaydi.",
      added: "{count} ta savol qo'shildi",
      added_plural: "{count} ta savol qo'shildi",
      cancel: 'Bekor qilish',
      errors: {
        noOptions: "{line}-qator: savoldan keyin variantlar yo'q. Savol va uning variantlari orasida bo'sh qator qoldirmang.",
        missingQuestion: "{line}-qator: savol matni yo'q — bu qator variantga o'xshaydi.",
        tooFewOptions: "{line}-qator: kamida 2 ta variant kerak.",
        tooManyOptions: "{line}-qator: ko'pi bilan 6 ta variant bo'ladi.",
        noCorrect: "{line}-qator: to'g'ri variant belgilanmagan. Uning oldiga * qo'ying.",
        multipleCorrect: "{line}-qator: bitta savolda faqat bitta to'g'ri variant bo'ladi.",
        emptyOption: "{line}-qator: variant matni bo'sh.",
      },
    },
    quiz: {
      timeLimitPlaceholder: 'Cheklanmagan',
      timeLimitHint: "1 dan 360 daqiqagacha. Bo'sh qoldirilsa — cheklanmagan.",
      timeLimitUnit: 'daq',
      noLimitAction: 'Cheklanmagan',
      timeLimitInvalid: "Vaqt chegarasi 1 dan 360 daqiqagacha butun son bo'lishi kerak.",
      lessonsFirstHint: "Test darsga biriktiriladi: avval kursga dars qo'shing.",
    },
    exams: {
      advancedSettings: "Qo'shimcha sozlamalar",
      advancedSettingsHint: "Kategoriya, imtihon turi, bo'limlar va ko'nikmalar",
      itemsLabel: 'Elementlar',
      itemsPlaceholder: "Har birini alohida qatorga",
      correctOrderLabel: "To'g'ri tartib",
      correctOrderPlaceholder: "Elementlarni to'g'ri tartibda, har birini alohida qatorga",
      emptyTextTitle: "{count} ta savolda matn yo'q",
      emptyTextTitle_plural: "{count} ta savolda matn yo'q",
      emptyTextDesc: "Matnsiz savollar saqlanmaydi: {numbers}. Ularni to'ldirish uchun qayting yoki ularsiz saqlang.",
      emptyTextSave: 'Ularsiz saqlash',
      emptyTextBack: 'Qaytish',
      issuesTitle: 'Saqlashdan oldin tuzating',
      timeLimitInvalid: "Vaqt chegarasi butun son bo'lishi kerak: kamida 1 daqiqa.",
      attemptsInvalid: "Urinishlar soni butun son bo'lishi kerak: kamida 1 ta.",
      publishNeedsQuestions: "Bu imtihonda savol yo'q. Nashr qilishdan oldin unga kamida bitta savol qo'shing.",
      multipleFinals: "Kursda {count} ta yakuniy imtihon bor. O'quvchilar hammasini ko'radi: keraksizini o'chiring yoki mashq imtihoniga aylantiring.",
      multipleFinals_plural: "Kursda {count} ta yakuniy imtihon bor. O'quvchilar hammasini ko'radi: keraksizini o'chiring yoki mashq imtihoniga aylantiring.",
      issue: {
        pickCorrect: "{index}-savol: to'g'ri javobni belgilang.",
        pickCorrectMany: "{index}-savol: kamida bitta to'g'ri javobni belgilang.",
        correctEmpty: "{index}-savol: to'g'ri deb belgilangan variant bo'sh.",
        needOptions: "{index}-savol: kamida 2 ta variant kerak.",
        duplicateOptions: "{index}-savol: ikki variant bir xil yozilgan.",
        needAnswer: "{index}-savol: to'g'ri javobni yozing.",
        needNumber: "{index}-savol: to'g'ri javob son bo'lishi kerak.",
        needItems: "{index}-savol: kamida 2 ta element kerak.",
        needOrder: "{index}-savol: to'g'ri tartibni yozing.",
        orderMismatch: "{index}-savol: to'g'ri tartib aynan shu elementlardan tuzilishi kerak.",
        needPairs: "{index}-savol: kamida 2 ta juftlik kerak (chap=o'ng).",
      },
    },
  },
  ru: {
    common: {
      addLessonAction: 'Добавить урок',
      addModuleAction: 'Добавить модуль',
      passMarkInvalid: 'Проходной балл должен быть целым числом от 0 до 100.',
    },
    options: {
      pickCorrectHint: 'Отметьте правильный ответ: нажмите на букву варианта',
      pickCorrectManyHint: 'Отметьте правильные ответы: можно выбрать несколько',
      pickOneHint: 'Выберите правильный ответ',
      trueOption: 'Верно',
      falseOption: 'Неверно',
    },
    bulk: {
      open: 'Добавить списком',
      title: 'Добавить вопросы списком',
      intro: 'Напишите вопросы текстом или вставьте их из другого места. Они добавятся в конец списка вопросов.',
      rulesTitle: 'Как писать',
      ruleQuestion: 'Вопрос — одна строка. Перед ним можно поставить 1) или 1.',
      ruleOptions: 'Варианты — на следующих строках, от 2 до 6. Можно начинать с A) или a.',
      ruleCorrect: 'Перед правильным вариантом поставьте *.',
      ruleBlank: 'Между вопросами оставьте пустую строку.',
      textareaLabel: 'Текст вопросов',
      placeholder: '1) Как по-русски «kitob»?\n*Книга\nТетрадь\nРучка\n\n2) Что значит слово «мама»?\nOta\n*Ona\nOpa',
      previewTitle: 'Предпросмотр',
      previewEmpty: 'Когда вы напишете текст, готовые вопросы появятся здесь.',
      readyCount: '{count} вопрос готов',
      readyCount_few: '{count} вопроса готовы',
      readyCount_plural: '{count} вопросов готовы',
      errorsCount: '{count} ошибка',
      errorsCount_few: '{count} ошибки',
      errorsCount_plural: '{count} ошибок',
      correctTag: 'Правильный',
      add: 'Добавить {count} вопрос',
      add_few: 'Добавить {count} вопроса',
      add_plural: 'Добавить {count} вопросов',
      addNothing: 'Добавить вопросы',
      fixErrorsFirst: 'Сначала исправьте ошибки: вопросы с ошибками не добавляются.',
      added: 'Добавлен {count} вопрос',
      added_few: 'Добавлено {count} вопроса',
      added_plural: 'Добавлено {count} вопросов',
      cancel: 'Отмена',
      errors: {
        noOptions: 'Строка {line}: после вопроса нет вариантов. Не оставляйте пустую строку между вопросом и его вариантами.',
        missingQuestion: 'Строка {line}: нет текста вопроса — эта строка похожа на вариант.',
        tooFewOptions: 'Строка {line}: нужно минимум 2 варианта.',
        tooManyOptions: 'Строка {line}: вариантов может быть не больше 6.',
        noCorrect: 'Строка {line}: правильный вариант не отмечен. Поставьте перед ним *.',
        multipleCorrect: 'Строка {line}: у вопроса может быть только один правильный вариант.',
        emptyOption: 'Строка {line}: пустой вариант.',
      },
    },
    quiz: {
      timeLimitPlaceholder: 'Без ограничения',
      timeLimitHint: 'От 1 до 360 минут. Пустое поле — без ограничения.',
      timeLimitUnit: 'мин',
      noLimitAction: 'Без ограничения',
      timeLimitInvalid: 'Ограничение по времени должно быть целым числом от 1 до 360 минут.',
      lessonsFirstHint: 'Тест привязывается к уроку: сначала добавьте в курс урок.',
    },
    exams: {
      advancedSettings: 'Дополнительные настройки',
      advancedSettingsHint: 'Категория, тип экзамена, разделы и навыки',
      itemsLabel: 'Элементы',
      itemsPlaceholder: 'Каждый с новой строки',
      correctOrderLabel: 'Правильный порядок',
      correctOrderPlaceholder: 'Элементы в правильном порядке, каждый с новой строки',
      emptyTextTitle: 'У {count} вопроса нет текста',
      emptyTextTitle_few: 'У {count} вопросов нет текста',
      emptyTextTitle_plural: 'У {count} вопросов нет текста',
      emptyTextDesc: 'Вопросы без текста не сохранятся: {numbers}. Вернитесь, чтобы заполнить их, или сохраните без них.',
      emptyTextSave: 'Сохранить без них',
      emptyTextBack: 'Вернуться',
      issuesTitle: 'Исправьте перед сохранением',
      timeLimitInvalid: 'Ограничение по времени должно быть целым числом: минимум 1 минута.',
      attemptsInvalid: 'Число попыток должно быть целым: минимум 1.',
      publishNeedsQuestions: 'В этом экзамене нет вопросов. Перед публикацией добавьте хотя бы один вопрос.',
      multipleFinals: 'В курсе {count} итоговых экзамена. Студенты видят их все: удалите лишний или сделайте его тренировочным.',
      multipleFinals_few: 'В курсе {count} итоговых экзамена. Студенты видят их все: удалите лишний или сделайте его тренировочным.',
      multipleFinals_plural: 'В курсе {count} итоговых экзаменов. Студенты видят их все: удалите лишний или сделайте его тренировочным.',
      issue: {
        pickCorrect: 'Вопрос {index}: отметьте правильный ответ.',
        pickCorrectMany: 'Вопрос {index}: отметьте хотя бы один правильный ответ.',
        correctEmpty: 'Вопрос {index}: вариант, отмеченный правильным, пустой.',
        needOptions: 'Вопрос {index}: нужно минимум 2 варианта.',
        duplicateOptions: 'Вопрос {index}: два варианта написаны одинаково.',
        needAnswer: 'Вопрос {index}: напишите правильный ответ.',
        needNumber: 'Вопрос {index}: правильный ответ должен быть числом.',
        needItems: 'Вопрос {index}: нужно минимум 2 элемента.',
        needOrder: 'Вопрос {index}: напишите правильный порядок.',
        orderMismatch: 'Вопрос {index}: правильный порядок должен состоять ровно из этих элементов.',
        needPairs: 'Вопрос {index}: нужно минимум 2 пары (слева=справа).',
      },
    },
  },
  en: {
    common: {
      addLessonAction: 'Add a lesson',
      addModuleAction: 'Add a module',
      passMarkInvalid: 'The pass mark must be a whole number from 0 to 100.',
    },
    options: {
      pickCorrectHint: "Mark the right answer: click the option's letter",
      pickCorrectManyHint: 'Mark the right answers: you can pick more than one',
      pickOneHint: 'Pick the right answer',
      trueOption: 'True',
      falseOption: 'False',
    },
    bulk: {
      open: 'Add from a list',
      title: 'Add questions from a list',
      intro: 'Type the questions as text or paste them from elsewhere. They are added after the questions you already have.',
      rulesTitle: 'How to write it',
      ruleQuestion: 'A question is one line. It may start with 1) or 1.',
      ruleOptions: 'Its options go on the lines below, 2 to 6 of them. They may start with A) or a.',
      ruleCorrect: 'Put * in front of the right option.',
      ruleBlank: 'Leave a blank line between questions.',
      textareaLabel: 'Questions text',
      placeholder: '1) How do you say «kitob» in Russian?\n*Книга\nТетрадь\nРучка\n\n2) What does «мама» mean?\nOta\n*Ona\nOpa',
      previewTitle: 'Preview',
      previewEmpty: 'Once you write some text, the questions that are ready show up here.',
      readyCount: '{count} question ready',
      readyCount_plural: '{count} questions ready',
      errorsCount: '{count} problem',
      errorsCount_plural: '{count} problems',
      correctTag: 'Correct',
      add: 'Add {count} question',
      add_plural: 'Add {count} questions',
      addNothing: 'Add questions',
      fixErrorsFirst: 'Fix the problems first: questions with a problem are not added.',
      added: '{count} question added',
      added_plural: '{count} questions added',
      cancel: 'Cancel',
      errors: {
        noOptions: 'Line {line}: there are no options after the question. Do not leave a blank line between a question and its options.',
        missingQuestion: 'Line {line}: there is no question text — this line looks like an option.',
        tooFewOptions: 'Line {line}: a question needs at least 2 options.',
        tooManyOptions: 'Line {line}: a question can have at most 6 options.',
        noCorrect: 'Line {line}: no option is marked right. Put * in front of it.',
        multipleCorrect: 'Line {line}: a question can have only one right option.',
        emptyOption: 'Line {line}: the option is empty.',
      },
    },
    quiz: {
      timeLimitPlaceholder: 'No limit',
      timeLimitHint: 'From 1 to 360 minutes. Leave it empty for no limit.',
      timeLimitUnit: 'min',
      noLimitAction: 'No limit',
      timeLimitInvalid: 'The time limit must be a whole number from 1 to 360 minutes.',
      lessonsFirstHint: 'A test belongs to a lesson: add a lesson to the course first.',
    },
    exams: {
      advancedSettings: 'More settings',
      advancedSettingsHint: 'Category, exam type, sections and skills',
      itemsLabel: 'Items',
      itemsPlaceholder: 'One per line',
      correctOrderLabel: 'Correct order',
      correctOrderPlaceholder: 'The items in the correct order, one per line',
      emptyTextTitle: '{count} question has no text',
      emptyTextTitle_plural: '{count} questions have no text',
      emptyTextDesc: 'Questions without text are not saved: {numbers}. Go back to fill them in, or save without them.',
      emptyTextSave: 'Save without them',
      emptyTextBack: 'Go back',
      issuesTitle: 'Fix before saving',
      timeLimitInvalid: 'The time limit must be a whole number: at least 1 minute.',
      attemptsInvalid: 'The number of attempts must be a whole number: at least 1.',
      publishNeedsQuestions: 'This exam has no questions. Add at least one question before you publish it.',
      multipleFinals: 'This course has {count} final exams. Students see all of them: delete the extra one or make it a practice exam.',
      multipleFinals_plural: 'This course has {count} final exams. Students see all of them: delete the extra one or make it a practice exam.',
      issue: {
        pickCorrect: 'Question {index}: mark the right answer.',
        pickCorrectMany: 'Question {index}: mark at least one right answer.',
        correctEmpty: 'Question {index}: the option marked right is empty.',
        needOptions: 'Question {index}: it needs at least 2 options.',
        duplicateOptions: 'Question {index}: two options are written the same.',
        needAnswer: 'Question {index}: write the right answer.',
        needNumber: 'Question {index}: the right answer must be a number.',
        needItems: 'Question {index}: it needs at least 2 items.',
        needOrder: 'Question {index}: write the correct order.',
        orderMismatch: 'Question {index}: the correct order must use exactly these items.',
        needPairs: 'Question {index}: it needs at least 2 pairs (left=right).',
      },
    },
  },
};

export default quizAuthoring;
